import { plural } from '../../utils/string'

export function formatShippingItemsTitle(shippingItemsCount?: number) {
  return `${shippingItemsCount} ${plural('item', shippingItemsCount || 0, 'items')}`
}
